import GoogleIcon from '@mui/icons-material/Google';
import { Button, InputAdornment, Stack, Typography } from "@mui/material";
import { useSnackbar } from 'notistack';
import React, { useRef } from "react";
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import '../../global.css';
import FormField from "../form/formField";
import { useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import authServices from '../../services/authServices';
import { saveUser } from '../../redux/reducers/userSlice';
import { getMyWatchlist } from '../../helpers/fetchWatchlist';
import logsService from '../../services/logServices';
import { InvestorActivityEventType } from '../../utils/eventTypes';
import CookieStorage from '../../utils/cookieStorage';
import ReCAPTCHA from "react-google-recaptcha";

const LoginForm = ({ number, setNumber, handleSendOtp,setLoading,setOtp,setShowTerms,onClose ,distributorCode, submitting = false }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const recaptchaRef = useRef(null);

    const submitWithCaptcha = async () => {
        if (submitting) return;
        try {
            const token = await recaptchaRef.current?.executeAsync();
            recaptchaRef.current?.reset();
            handleSendOtp(token);
        } catch (error) {
            enqueueSnackbar("Captcha verification failed", { variant: "error" });
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter" && number?.length === 10 && !submitting) {
            submitWithCaptcha();
        }
    };

    const handleGoogleLogin = useGoogleLogin({
        scopes: 'profile email https://www.googleapis.com/auth/user.phonenumbers.read',
        onSuccess: async (codeResponse) => {
            setLoading(true);  // Start loader when the process starts
            const userInfo = await axios
                .get('https://www.googleapis.com/oauth2/v3/userinfo', {
                    headers: { Authorization: `Bearer ${codeResponse.access_token}` },
                })
                .then(async (googleResponse) => {
                    const data = {
                        email: googleResponse.data.email,
                        distributorCode: distributorCode,
                    }
                    const res = await authServices.googleLogin(data);
                    if (res && res.success && res?.data?.length > 0) {
                        CookieStorage.set('access', res.token.access.token, { path: '/', days: 7 });
                        CookieStorage.set('refresh', res.token.refresh.token, { path: '/', days: 15 });
                        const userWithUrl = {
                            ...res.data[0],
                            url: res.url,
                        };
                        dispatch(saveUser(userWithUrl));
                        await getMyWatchlist(dispatch)
                        logsService.addLog({
                            userId: res.data[0]?._id,
                            event: InvestorActivityEventType.GOOGLE_LOGIN
                        })
                        if (res.data[0].conditionAccepted) {
                            enqueueSnackbar("Logged in successfully", { variant: "success" })
                            navigate(`/dashboard?show=${(res.data[0]?.status === "FIRST_TIME" || res.data[0]?.status === "REGISTERED" || res.data[0]?.status === "KYC_APPROVED")}`, { state: res.data[0]?.status });
                        }
                        else {
                            setOtp(true);
                            setShowTerms(true);
                            onClose();
                        }
                    }
                    else {
                        if (res.data.message) {
                            enqueueSnackbar("OTP is incorrect", { variant: "error" })
                        }
                        else {
                            enqueueSnackbar("Something went wrong!", { variant: "error" })
                        }
                    }
                })
                .catch(err => enqueueSnackbar(err.message || "Something went wrong!", { variant: "error" }))
                .finally(() => {
                    setLoading(false);  // Stop loader when everything is finished
                });
        },
        onError: (error) => {
            console.log("Google Sign in error:", error)
            enqueueSnackbar("Something went wrong!", { variant: "error" })
            setLoading(false);  // Stop loader when everything is finished
        }
    })  
    return (
        <>
            <Stack spacing={1.5} mt={3}>
                <FormField label={"Enter Mobile No *"} inputProps={{
                    placeholder: "",
                    // type:"number",
                    value: number,
                    onChange: (e) => {
                        // console.log(RegExp('^[0-9]*$').test(e.target.value));
                        if (RegExp('^[0-9]*$').test(e.target.value) && e.target.value?.length < 11) {
                            setNumber(e.target.value)
                        }
                    },
                    onKeyPress: handleKeyPress,
                    InputProps: {
                        startAdornment: <InputAdornment position="start">
                            <Typography variant="body2" sx={{ color: "text.primary" }}>+91</Typography>
                        </InputAdornment>,
                        // endAdornment:<InputAdornment position="end">
                        //     <Button disabled={!(number?.length === 10)} variant="text">Send OTP</Button>
                        // </InputAdornment>
                    }
                }} />
                {/* <Stack direction={"row"} spacing={0.5} justifyContent={'center'}>
                    <Typography variant="body2">Have an invite code?</Typography>
                    <Typography onClick={()=>setSignUp(true)} variant="body2" sx={{color:"primary.main",cursor:"pointer"}}>Signup</Typography>
                </Stack> */}
            </Stack>
             <ReCAPTCHA
                ref={recaptchaRef}
                sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                size="invisible"
                badge="bottomright"
             />
            <Button onClick={submitWithCaptcha} disabled={!(number?.length === 10) || submitting} variant="contained" sx={{ mt: 3 }} fullWidth >{submitting ? "Sending..." : "Send OTP"}</Button>
            <Button onClick={handleGoogleLogin} variant="contained" sx={{ mt: 4 }} fullWidth >
                Sign in with <GoogleIcon
                    color=""
                    sx={{ ml: 0.5, fontSize: "15px" }}
                    onClick={handleGoogleLogin}
                />
            </Button>
        </>
    )
}

export default LoginForm